import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import API_URL from "./Apiurl";
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/EditSquare';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import { withStyles } from "@mui/styles";
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import BlockIcon from '@mui/icons-material/Block';
import PersonIcon from '@mui/icons-material/Person';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import ListAltIcon from '@mui/icons-material/ListAlt';
import {InputAdornment} from "@mui/material";
const headCells = [


 
  
  { id: 'wc_categoryname', numeric: false, label: 'Title' },

  
   { id: '',  label: '' },
  ]
  
  

 
 function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
 
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class Wages extends Component {
	
    constructor(props) {
    super(props);
   
      this.state = {redirect: false,
      Wagecategorydata:[],wcid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:10,rowsPaging:[],
	 
	  order:'desc' ,orderBy:'',wcstatus:'',names:'',searchcustomer:'',
	          
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   this.addWagecategoryboxRef = React.createRef();
	}
	
	updateDonenewParent = (text) => {  this.apicall(this.state.page,this.state.rowsPerPage); }
	
	componentWillMount() { 
		
		if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="Wages Category";   
			 this.props.parentsCallback(
           strname
        );
		
		document.title = "VR Builders - Wages Category";
			  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
  


}






  


handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 

myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
}

apicall(page,rowsPerPage){
	 
	 axios.get(API_URL+'ajaxwagecategory.php?action=getall&wc_status='+this.state.wcstatus+'&wc_type=1&wc_categoryname='+this.state.names+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  Wagecategorydata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
			let copy=[10,20,50, 100, 150, 200, 250];
			
	  
	  this.setState({rowsPaging:copy});
	 
     }
	 else{
		   this.setState({Wagecategorydata:[],totaldata:0});
	 }
 
    });
}





handleChangePage = (event, newPage) => {  
   
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:parseInt(pageval)
    },()=>{  this.apicall(this.state.page,this.state.rowsPerPage);});
   
 
  
  };  
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
    localStorage.setItem("page",pageval)


    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{  this.apicall(this.state.page,this.state.rowsPerPage);}); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};


      wagecategoryDelete(wcid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r === true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('wc_id',wcid)
	 	   
formData.append('userid',localStorage.getItem("VRuserid"))	
	
	
	 axios.post(API_URL+"ajaxwagecategory.php", formData, {
        }).then(res => {
    
           
  this.apicall(this.state.page,this.state.rowsPerPage);
  
    
            });
 }
      }
wagecategorystatus(wcid,state){  
	
	
	
let strmsg=" Block";
	
	if(state===0)
	{
		strmsg=" Unblock";
	}
let r = window.confirm("Do you really want to "+strmsg+"?");
 if(r === true){ 
 var formData = new FormData();
     formData.append('action','statusupdate')
	 formData.append('wc_id',wcid)
	 	 formData.append('wc_isactive',state)   
formData.append('userid',localStorage.getItem("VRuserid"))	
	
	
	 axios.post(API_URL+"ajaxwagecategory.php", formData, {
        }).then(res => {
      this.apicall(this.state.page,this.state.rowsPerPage);
  
    
            });
 }
      }	  
	  

 Wagecategoryaddbox(val){
        this.setState({ wcid: val },()=>{this.addWagecategoryboxRef.current.handleClickOpen()});  
  
         

      }
render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
   


   <div className="searchmaster">


  
  <ul>
  

		
		<li>
 <p ><TextField
            variant="outlined"
            margin="normal" className="inputcntlparent" size="small"
            fullWidth value={this.state.names}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="Title"
            name="names" onChange={this.myChangeHandler}
		
          /></p></li>
			 <li>
 	<p><FormControl  className="stadrp">			   
		<Select className="inputcntlparent" size="small"
		variant="outlined"
		native
		value={this.state.wcstatus}
		onChange={this.myChangeHandler}
		name='wcstatus'
		id='wcstatus'
		placeholder="Status"
		InputLabelProps={{
		shrink: true,
		}}
		>
			<option value="">Select Status</option>
		<option value={0}>Active</option>
		<option value={1}>In Active</option>	
		</Select>
		</FormControl></p>	
</li>
<li>
<p className="searchbutton">
		<Button variant="contained" onClick={this.handleClickSearch} className={useStyles.submit} endIcon={<SearchIcon />}>
        Search
      </Button>	<Button variant="contained" onClick={()=>{this.Wagecategoryaddbox(0)}} className="pointerbtn" endIcon={<AddIcon />}>
        New
      </Button></p>
</li>
	</ul>
		
	

		
		
</div>		


<AddExpensebox
  ref={this.addWagecategoryboxRef}
  id={this.state.wcid}
  updateDonenew={this.updateDonenewParent}
/>

<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Wagecategorydata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Wagecategorydata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.wc_categoryname}</TableCell>


<TableCell align="left">
{(item.wc_id!=="4" && item.wc_id!=="5") && (
<div className="actionbtns">
<Button variant="contained" className="editbtn" onClick={()=>{this.Wagecategoryaddbox(item.wc_id)}} endIcon={<EditIcon />}>

</Button>&nbsp;
{ item.delcount==="0" && (
<Button variant="contained" className="deletebtn" onClick={()=>{this.wagecategoryDelete(item.wc_id)}} endIcon={<DeleteIcon />}>
  
</Button> )}&nbsp;


 {item.wc_isactive !=='1' &&(<React.Fragment> 
 
<Button variant="contained" className="statusbtnblock" onClick={()=>{this.wagecategorystatus(item.wc_id,1)}} endIcon={<PersonIcon />}>
  
</Button> 
 </React.Fragment>)}
 {item.wc_isactive !=='0' &&(<React.Fragment> 
 
<Button variant="contained" className="statusbtn" onClick={()=>{this.wagecategorystatus(item.wc_id,0)}} endIcon={<PersonOffIcon />}>
 
</Button> 
 </React.Fragment>)}

 
 </div>
)}
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colSpan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[10,20, 100, 150, 200, 250]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />   
  </Paper>
    

 </React.Fragment> 

 
 
  );
}
}
export class AddExpensebox extends Component{
	
	constructor(props) {
      super(props)
	  
      this.state = {
		  
		   open:false,names:'',wc_id:0,errormessage:'',erropen:false, 
	  }
      
  }

 
Expensegetdata() {
  if (this.props.id !== 0) {
    axios.get(API_URL + 'ajaxwagecategory.php?action=getall&wc_id=' + this.props.id)
    .then(resp => {  
      if (resp.data.length > 0) {
        this.setState({ 
          wc_id: resp.data[0].wc_id,
          name: resp.data[0].wc_categoryname || ''
        });
      }
    });
  } else {
    this.setState({
      name: '',
      wc_id: 0
    });
  }
}
	 

	onclickclose = (e) => {
	 this.setState({open:false});
}


   
handleClickOpen = (e) => {
  this.setState({
    open: true,
    name: '',
    wc_id: 0,
    errormessage: '',
    erropen: false
  }, () => {
    this.Expensegetdata();
  });
};
myChangeHandler = (event) => {

  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val}); 
}


 handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }


handleSubmit = (e) => {
	
	
 let name = this.state.name;


  


if(name==="")
{
	
	this.setState({errormessage:"Please Enter Title",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}


   var formData = new FormData();
  
  
   if(this.state.wc_id===0)
	  {
		  formData.append('wc_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('wc_id',this.state.wc_id)
		
          }
	  
	  formData.append('action','insertorupdate') 
		
		formData.append('wc_categoryname',name)	
		
			formData.append('wc_type',1)
		formData.append('userid',localStorage.getItem("VRuserid"))
		 
		axios.post(API_URL+"ajaxwagecategory.php", formData, {
        }).then(res => {
    
	    if(res.data === -1)
{ 
	 

		this.setState({errormessage:"Title Already Exist.",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}
            this.props.updateDonenew();
    
        });
  
	
	this.setState({ open:false });
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

	


render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.onclickclose} maxWidth="md" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Wages Category</DialogTitle>
      <DialogContent>
	  
<div className="formlist">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
		<ul>
			  
						  
	<li><p> <span className="validation">*</span> Title</p>
	
	<p><TextField name="name" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   size="small"
	   value={this.state.name}
			 		  slotProps={{
    htmlInput: {
      maxLength: 150,
      tabIndex: 1
    },
    input: {
      endAdornment: (
        <InputAdornment position="end">
          <ListAltIcon sx={{ color: "#206ccc", fontSize: 20 }} />
        </InputAdornment>
      )
    }
  }}
			 
			  inputProps={{tabIndex: "1",maxLength:150}} 
	   InputLabelProps={{ shrink: true }}
                          /></p></li>
		
		

		
		</ul>
		

		
		
       <div className="actionbtns">
<div className="cancelbtn">	  
        <Button className="frmsecondarybtn" onClick={this.onclickclose } color="secondary">
          Cancel
        </Button>
</div> 
<div className="savebtn">
        <Button className="frmPrimarybtn" onClick={this.handleSubmit} color="secondary">
          Save
        </Button>
		</div>
<div className="clear"></div>

 </div>     
			 
 </div> 		
 </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
 
}

 
  